module.exports = __webpack_public_path__ + "static/media/invite-white-small.fbcf7b6c.svg";